module.exports = "/_next/static/images/07-9dc639583f3afa3f2f721e74b517e03b.png";